import { Accordion, Button } from "devextreme-react";
import styled from "styled-components";
import IssueCountPivotGrid from "./IssueCountPivotGrid";

const IssuesSummaryWrapper = styled.div`
  width: 100%;
  > div:first-child {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    .dx-button {
      margin: 0;
    }
    h3 {
      margin: 0;
      font-size: 1em;
    }
  }
`;

const IssuesSummary = ({ contrNo, setMode, yearMonth }) => {
  const accordionDataSource = [
    { index: 0, target: "stat", targetName: "Issue Status", title: "Current Status" },
    { index: 1, target: "type", targetName: "Issue Type", title: "Issue Type" },
  ];

  const handleClickMode = () => {
    setMode("issueEdit");
  };

  const renderAccordionItem = (e) => {
    return (
      <IssueCountPivotGrid
        contrNo={contrNo}
        isVisible={true}
        showChart={false}
        target={e.target}
        targetName={e.targetName}
        yearMonth={yearMonth}
      />
    );
  };

  return (
    <IssuesSummaryWrapper>
      <div>
        <h3>Issues</h3>
        <Button onClick={handleClickMode} stylingMode="contained" text="DETAILS" type="success" />
      </div>
      <Accordion
        collapsible={true}
        dataSource={accordionDataSource}
        defaultSelectedItemKeys={[0, 1]}
        deferRendering={false}
        keyExpr="index"
        itemRender={renderAccordionItem}
        multiple={true}
      />
    </IssuesSummaryWrapper>
  );
};

export default IssuesSummary;
